import { doorOpen, phaseOf, type TournamentSummary } from "./tournament";
import type { Field, ScheduledGame } from "./types";

/** Registration is a manual status, so it alone cannot prove the event has
 * not started or that its deadline still permits entry. Use the server's
 * event-local minute for the entry door, just like the registration form. */
export function showsTournamentInfo(
  meta: TournamentSummary,
  schedule: readonly ScheduledGame[],
  now: Date,
): boolean {
  return (
    doorOpen(meta, meta.wallNow) &&
    phaseOf(meta, now) === "upcoming" &&
    !schedule.some((game) => game.result !== undefined)
  );
}

/** A field is useful to visitors once it hosts a game or has a stream.
 * Unused setup rows (including the initial Main Field) are not venue details. */
export function infoFields(fields: readonly Field[], schedule: readonly ScheduledGame[]): Field[] {
  const scheduled = new Set(schedule.map((game) => game.fieldId));
  return fields.filter((field) => scheduled.has(field.id) || Boolean(field.streamUrl))
    .sort((a, b) => a.order - b.order);
}
